import React, { useContext, useEffect, useState } from "react";

import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { QREditorContext } from "@/contexts/QREditorContext";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";

import { applyQRFormDefaultValues } from "@/utils/formHelper";
import {
  omittedValues,
  onBindImage,
  onBindSocialNetworks,
  onBindThemePicker,
} from "@/utils/qrEditorHelper";
import { qrVcardValidation } from "@/utils/validators/qr-vcard";
import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";
import { QRVcardProps } from "./types";
import "./styles.scss";

export function QRVcard({ data }: QRVcardProps) {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = useContext<QREditorContextProps<"vcard">>(QREditorContext);

  const [qrVcardData, setQrVcardData] = useState<QRProps<"vcard">>(qrData);
  const [renderForm, setRenderForm] = useState(false);

  const dataVcardWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  onBindImage(dataVcardWithDefaultValues, "qrVcardImage", omittedValues(qrData.data));
  onBindThemePicker(dataVcardWithDefaultValues, "qrVcardThemePicker", omittedValues(qrData.data));
  onBindSocialNetworks(
    dataVcardWithDefaultValues,
    "qrVcardSocials",
    "socialNetworks",
    omittedValues(qrData.data)
  );

  const onUpdateState = ({ field, value }) => {
    if (field === "file" || field == "") return;
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          [field]: value,
        },
      },
      omittedValues(qrData.data)
    );
  };

  useEffect(() => {
    setQrVcardData(qrData);
  }, [qrData]);

  useEffect(() => {
    setQrData({ ...qrVcardData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-vcard">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataVcardWithDefaultValues}
        schema={qrVcardValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
}
